import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-crew-edit-history',
  templateUrl: './fes-workflow-action-crew-edit-history.component.html',
  styleUrls: ['./fes-workflow-action-crew-edit-history.component.scss']
})
export class FesWorkflowActionCrewEditHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
